import React from "react";

export const titlePage = (title) => window.setPageTitle(title);
